module.exports = __webpack_public_path__ + "static/media/so-algo-horse1.c920401e.jpg";